export const workoutHasRecordedProgress = workout => {
  const exercises = Array.isArray(workout?.data?.exercises) ? workout.data.exercises : [];
  return exercises.some(exercise => {
    const sets = Array.isArray(exercise?.sets) ? exercise.sets : [];
    return sets.some(set => set?.complete === true);
  });
};

export const getPendingWorkoutAction = workout => {
  if (workout?.type !== 'workout' || workout?.status !== 'pending') return null;
  if (
    workout?.travel_replacement_locked === true
    || Boolean(workout?.travel_replacement_id)
  ) return null;
  const hasProgress = workoutHasRecordedProgress(workout);
  return {
    label: hasProgress ? 'Resume Workout' : 'Start Workout',
    hasProgress,
  };
};
